import store from "../store";
import { errorDebug } from "./common";
import * as LDClient from 'launchdarkly-js-client-sdk';

export const launchDarklyClient = LDClient.initialize(window['launchDarklyEnv'] || process.env.VUE_APP_LD_ENVIRONMENT, { kind: 'user', key: 'none', email: 'none' });
launchDarklyClient.on('change', () => store.state.flags = launchDarklyClient.allFlags());
launchDarklyClient.on('error', err => { errorDebug(err); store.state.flags = {}; });
